import React from 'react';
import Modal from '@/page/subscription/new/components/modal';
import PayQrContent from '@/components/pay-qr-content';
import styles from './index.module.css';

interface PayQrModalProps {
  visible: boolean;
  onClose: () => void;
}

const PayQrModal: React.FC<PayQrModalProps> = ({ visible, onClose }) => {
  return (
    <Modal
      visible={visible}
      onClose={onClose}
      style={{
        width: 400,
        height: 'fit-content',
        background:
          'linear-gradient(159deg, #523a02 -7.63%, #000207 32.7%, #000207 77.64%, #312000 106.84%)',
      }}
    >
      <PayQrContent className={styles.container} />
    </Modal>
  );
};

export default PayQrModal;
